module.exports = __webpack_public_path__ + "static/media/edit-workspace-icon.00d9d084.svg";